module.exports = __webpack_public_path__ + "e99543bb86794e15928d03e9b41bb3c8.svg";